import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  PageInteractionsRecommendationsForm,
  PageInteractionsRecommendationsProps,
} from './PageInteractionsRecommendationsForm';
import { Namespace } from '../../../../translation/namespace';
import useCollapsibleOverlay from '../../../../hooks/useCollapsibleOverlay';
import { ButtonMinorAction } from '../../../../components/molecules/Btn/ButtonWrapper';
import { Icons } from '../../../../components/atoms/SVG';
import { CollapsibleContent } from '../../../../components/organisms/CollapsibleOverlay/CollapsibleOverlay';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';

export function PageInteractionsRecommendationButton({ form }: { form: PageInteractionsRecommendationsProps['form'] }) {
  const { t } = useTranslation(Namespace.PageInteractions);
  const { closeCollapsible, collapsibleOpen, collapsibleProps, toggleProps, popperInstance } =
    useCollapsibleOverlay('bottom');

  useEffect(() => {
    if (collapsibleOpen && popperInstance) {
      popperInstance.update();
    }
  });

  return (
    <div className="page-interactions__button-container">
      <ButtonMinorAction
        icon={collapsibleOpen ? Icons.DECLINE_CROSS : Icons.RECOMMEND_PAPERPLANE}
        text={t(`recommendation.buttonText`)}
        onClick={toggleProps.onClick}
        onKeyDown={toggleProps.onKeyDown}
        ariaControls={toggleProps['aria-controls']}
        popoverTarget={toggleProps.popoverTarget}
        popoverTargetAction={toggleProps.popoverTargetAction}
        reference={toggleProps.ref}
        tooltipPlacement={TooltipPlacement.TOP}
      />
      <CollapsibleContent {...collapsibleProps}>
        <PageInteractionsRecommendationsForm form={form} closeCollapsible={closeCollapsible} />
      </CollapsibleContent>
    </div>
  );
}
